import { render } from "./Share.vue?vue&type=template&id=43c8836c"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=43c8836c&scope=true&lang=scss"
script.render = render

export default script